import React from 'react';
import Dialog, { DialogProps } from '../../../../components/dialog/Dialog';

const ComingSoonModal: React.FC<DialogProps> = ({ ...props }) => {
    return (
        <Dialog {...props}>
            <div className="mt-12 px-24 pb-40">
                <div className="flex flex-col items-center text-center">
                    <p className="text-10 font-semibold text-white px-6 py-4 rounded-4 bg-gradient-dark2">
                        COMING SOON
                    </p>
                    <p className="mt-12 text-28 leading-30 font-bold">
                        This block is for Grow account users and is coming soon.
                    </p>
                    <p className="mt-12 text-18 leading-20 text-primary-80">
                        Check back soon to upgrade and add this feature to your .site.
                    </p>
                </div>
            </div>
        </Dialog>
    );
};

export default ComingSoonModal;
